'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = operations;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    preload: false,
    morePreload: false,
    items: [],
    count: 0,
    endDate: "",
    begDate: "",
    page: 1
};

function operations() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.OperationsConstants.OPERATION_LOAD:
            return (0, _extends3.default)({}, state, {
                preload: true
            });

        case _constants.OperationsConstants.MORE_LOAD:
            return (0, _extends3.default)({}, state, {
                morePreload: true
            });

        case _constants.OperationsConstants.OPERATION_LOAD_SUCCESS:
            return (0, _extends3.default)({}, state, {
                items: action.result.data.items,
                count: action.result.data.count,
                endDate: action.result.endDate,
                begDate: action.result.begDate,
                multiBalans: action.result.multi_balans,
                page: action.result.page,
                preload: false,
                morePreload: false
            });

        case _constants.OperationsConstants.MORE_LOAD_SUCCESS:
            var newItems = state.items.concat([].concat((0, _toConsumableArray3.default)(action.result.data.items)));

            return (0, _extends3.default)({}, state, {
                items: newItems,
                count: action.result.data.count,
                endDate: action.result.endDate,
                begDate: action.result.begDate,
                multiBalans: action.result.multi_balans,
                page: action.result.page,
                preload: false,
                morePreload: false
            });

        case _constants.OperationsConstants.OPERATION_LOAD_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                morePreload: false
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/operations.js
// module id = 1905
// module chunks = 0